<template>
  <div>
      <Edit
      :item="currentItem"
      :close="closeEdit"
      :submit="submit"
      :update="update"
    ></Edit>
    <div class="filters row" style="margin-top:0; justify-content: flex-end;">
      <div class="col-1-12">
        <div class="pull-right">
          <button v-on:click="openCreate" class="button button-success button-block">
            <fa-icon icon="plus" /> Novo Mershandising
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Id</th>
            <th>Sugestão</th>
            <th>Descrição</th>
            <th>Tipo</th>
            <th style="display: flex; justify-content: center;">Image</th>
            <th>Ativo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in this.items" v-bind:key="item.id" >
            <td class="highlight">{{ item.id }}</td>
            <td>{{ item.sugestao }}</td>
            <td>{{ item.descricao }}</td>
            <td>{{ item.tipo }}</td>
            <td style="display: flex; justify-content: center;">
              <img :src="item.imagem" class="thumbnail thumbnail-extra-small jus">
            </td>
            <td>
              <span class="label success" v-if="item.ativo">Ativo</span>
              <span class="label error" v-else>Inativo</span>
            </td>
            <td class="actions">
              <button type="button" class="button button-primary" v-on:click="openEdit(item)"><fa-icon icon="pencil-alt" /></button>
              &nbsp;
              <button type="button" name="button" v-on:click="remove(item.id)" class="button button-error"><fa-icon icon="trash-alt" /></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import clone from "just-clone";

import { get, post, put, del } from "../../../../helpers/apiRequest";
import Edit from "./Edit";

export default {
  name: "mershandising-list",
  components: {
    Edit,
  },
  props: ["items", "loadMershandising"],
  data() {
    return {
      descPlural: "",
      loading: false,      
      currentItem: {},
      table: {
        filter: "",
        columns: [
          { label: "ID", field: "id", align: "center", sortable: false },
          { label: "Descricao", field: "descricao", sortable: false },
          { label: "Sugestão", field: "sugestao", sortable: false },
          { label: "Tipo", field: "tipo", sortable: false },
          {
            label: "Imagem",
            field: "imagem",
            sortable: false,
          },
          { label: "Status", field: "ativo", sortable: false },
        ],
        paginator: {},
      },
    };
  },
  computed: {},
  methods: {
    openCreate() {
      this.openEdit({
        sugestao: null,
        descricao: null,
        tipo: null,
        ativo: 1,
        imagem: "",
      });
    },
    closeCreate() {
      this.$modal.hide("mEdit");
    },
    openEdit(item) {
      this.currentItem = clone(item);
      this.$modal.show("mEdit");
    },
    closeEdit() {
      this.$modal.hide("mEdit");
    },
    submit(item) {
      post("/admin/mershandising/save", item)
        .then((json) => {
          this.$modal.hide("mEdit");
          this.loadMershandising();
          this.$swal({
            title: 'Salvo com sucesso',
            text: json.message,
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'success',
          }); 
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            title: "Ops!",
            text: error.message,
            icon: "error",
          });
        });
    },
    update(item) {
      put(`/admin/mershandising/update/${item.id}`, item)
        .then((json) => {
          this.$modal.hide("mEdit");
          this.loadMershandising();
          this.$swal({
            title: 'Salvo com sucesso',
            text: json.message,
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'success',
          });  
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            title: "Ops!",
            text: error.message,
            icon: "error",
          });
        });
    },
    remove(id) {
      this.$swal({
        title: "Confirma Remover?",
        text: "Essa ação não poderá ser desfeita",
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            del(`/admin/mershandising/delete/${id}`)
              .then((json) => {
                this.loading = false;
                this.loadMershandising();
                this.$swal({
                  title: 'Removido com sucesso',
                  text: json.message,
                  showCancelButton: false,
                  cancelButtonText: 'Fechar',
                  showConfirmButton: true,
                  icon: 'success',
                });  
              })
              .catch((error) => {
                this.loading = false;
                this.$swal({
                  title: "Ops!",
                  text: error.message,
                  icon: "error",
                });
              });
          }
        })
        .catch(() => {});
    },
  },  
};
</script>
